import { usePlayroomCoinEventValues } from '@crehana/compass.playroom';
// biome-ignore lint/style/noRestrictedImports: legacy import kept for compatibility
import { useParams } from 'react-router-dom';

import { useLearnDashboardContext } from '@/views/LearnDashboard/context';

import { useGetDetailTrackByIdQueryQuery } from '../../graphql/GetDetailTrackByIdQuery.v5.generated';
import parseDataDetailTrack from '../../utils/parseDataDetailTrack';

const useGetDetailTrack = () => {
  const { id } = useParams<{ id: string }>();
  const { organizationSlug, me } = useLearnDashboardContext();
  const organizationId = me.organization?.originalId?.toString() as string;

  const { data, loading, error } = useGetDetailTrackByIdQueryQuery({
    fetchPolicy: 'network-only',
    context: {
      clientName: 'v5',
    },
    variables: {
      input: {
        organization_team_id: Number(id),
        organization_id: Number(organizationId),
      },
    },
  });

  const { playroomLearningPathCoins } = usePlayroomCoinEventValues(
    organizationSlug as string,
    organizationId,
  );

  return {
    data: parseDataDetailTrack(
      data?.content_organization_team?.user_organization_team,
      playroomLearningPathCoins,
    ),
    loading: loading,
    error,
  };
};

export default useGetDetailTrack;
